import React from "react";
import { Card, Grid, Typography, CircularProgress, Box } from "@mui/material";
import LineChartSales from "./LineChartSales";
import ChartOrderRevenue from "./ChartOrderRevenue";
import renderSalesData from "./renderSalesData";
import { dataItems, menuItems } from "./data";

import JumboContent from "@jumbo/components/JumboContent";
import Div from "@jumbo/shared/Div";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import LineChartBasic from "./lineChartBasic";
import { useSelector } from "react-redux";

const SalesStatistics = ({
  reportingTiles,
  reportingOverviewGraphData,
  dashboardDateFilter,
  tabLoaders,
  detailsTab,
  xAxis,
  interval,
  inputLabels,
  reportingLabelPostion,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { authUserData } = useSelector((state) => state.CommonReducer);

  let inputData = {
    dataKey: "hour",
    oyLabel: "KWh",
    oxLabel: "hours",
    yLimit: [0, 20000],
  };
  return (
    <Card style={{ marginBottom: "10px" }}>
      <JumboContent>
        <Grid container>
          <Grid item xs={12} lg={12}>
            <Div
              sx={{
                p: (theme) => theme.spacing(3, 2, 3, 0),
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {tabLoaders &&
              tabLoaders.length &&
              (tabLoaders.indexOf("graph") != -1 ||
                tabLoaders.indexOf("impressions_clicks") != -1) ? (
                <CircularProgress
                  sx={{
                    zIndex: 4,
                    position: "absolute",
                    // //top: "5px",
                    // //right: "5px",
                    // transform: "translate(-50%, -50%)",
                    // transform: "-webkit-translate(-50%, -50%)",
                    // transform: "-moz-translate(-50%, -50%)",
                    // transform: "-ms-translate(-50%, -50%)",
                  }}
                />
              ) : (
                ""
              )}

              {reportingOverviewGraphData &&
              reportingOverviewGraphData.length ? (
                <LineChartBasic
                  reportingOverviewGraphData={reportingOverviewGraphData}
                  labels={inputLabels}
                  {...inputData}
                  dashboardDateFilter={dashboardDateFilter}
                  xAxis={xAxis}
                  interval={interval}
                  graphConfigInfo={{
                    lableTextAnchor: reportingLabelPostion,
                  }}
                />
              ) : tabLoaders.indexOf("graph") == -1 &&
                tabLoaders.indexOf("impressions_clicks") == -1 ? (
                <Box
                  sx={{ position: "relative" }}
                  style={{
                    height: Math.max(window.innerHeight - 500, 250) + "px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  No data available.
                </Box>
              ) : (
                <Box
                  sx={{ position: "relative" }}
                  style={{
                    height: Math.max(window.innerHeight - 500, 250) + "px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                ></Box>
              )}

              {/* <LineChartSales reportingOverviewGraphData={reportingOverviewGraphData}/> */}
            </Div>
          </Grid>
        </Grid>
      </JumboContent>
      {detailsTab ? (
        <JumboContent
          bgColor={theme.palette.primary.main}
          sx={{ color: "common.white" }}
        >
          {tabLoaders &&
          tabLoaders.length &&
          tabLoaders.indexOf("graph") != -1 ? (
            <Div
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress
                style={{
                  height: "20px",
                  width: "20px",
                  color: "white",
                }}
                sx={{
                  zIndex: 4,
                  position: "absolute",
                  top: "40%",
                  //right: "5px",
                  transform: "translate(-50%, -50%)",
                  transform: "-webkit-translate(-50%, -50%)",
                  transform: "-moz-translate(-50%, -50%)",
                  transform: "-ms-translate(-50%, -50%)",
                }}
              />
            </Div>
          ) : null}

          {renderSalesData(reportingTiles, authUserData)}
        </JumboContent>
      ) : (
        ""
      )}
    </Card>
  );
};

export default SalesStatistics;
